import React, { useMemo } from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon = ({ src, ...props }: any) => {
  return <img src={src || "/images/none_logo.png"} {...props} alt="" />;
};

export default Icon;
